<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/delivery-options" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Versandbedingungen hinzufügen</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newCategoryForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 form-div">
                <b-form-group>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Die Label-Option ist erforderlich',
                    }"
                  >
                    <v-text-field
                      :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.optionLabel"
                      label="Lieferbedingung"
                      outlined
                    ></v-text-field>
                    <span>{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group>
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Aktiviert' : 'Deaktiviert'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn
                    class="submit-btn-fill-outline"
                    @click="goToBack"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="Abschicken"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="options" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
//import axios from "axios";
import Notifications from "vue-notification";
//import JwtService from "@/core/services/jwt.service";
import adminAPI from "@/api/admin";

Vue.use(Notifications);
export default {
  name: "AddDeliveryOption",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.userId = localStorage.getItem("local_products_user_access_id");
    }
  },
  data() {
    return {
      formError: false,
      userId: null,
      formData: [],
      btnDisable: false,
      submitText: "Abschicken",
      status: true,
      form: {        
        optionLabel: null,        
      },
    };
  },
  methods: {
    goToBack() {
      this.$router.push({ name: "delivery-options" });
    },
    onSubmit() {
      this.$refs.newCategoryForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.submitText = "Wird abgeschickt...";
          let fd = new FormData();
          fd.append("lable", this.form.optionLabel);
          fd.append("status", this.status == true ? "1" : "0");
          setTimeout(() => {
            adminAPI
              .addDeliveryOption(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Abschicken"
                  this.btnDisable = false;
                  this.$notify({
                    group: "options",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "delivery-options" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Abschicken";

                  this.$notify({
                    group: "options",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Abschicken";
                this.$notify({
                  group: "options",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Abschicken";
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
